import React, {useContext} from "react";

// Auth Context
export const AuthContext = React.createContext({});

export const useAuthState = () => {
    // @ts-ignore
    return useContext(AuthContext);
};